/***
 *
 *   CONTENT CONTAINER
 *   Horizontal page gutter. Ported verbatim from
 *   ui-reference/src/components/layouts/content-container.tsx.
 *
 *   PROPS
 *   as: element to render (default: div)
 *   className: injected classes
 *
 **********/

import { cn } from 'components/lib';

export function ContentContainer(props) {
    const { as: Element = 'div', className, children, ...rest } = props;

    return (
        <Element className={cn('w-full px-4 md:px-6 lg:px-8', className)} {...rest}>
            {children}
        </Element>
    );
}
